import { handleResponseError } from "helpers/utils"
import { API } from "./endpoint"
import httpClient from '../axios/interceptors'
import { AxiosResponse } from "axios"
import { RequestAgentNewsInput, RequestInputCreateNews, RequestInputDeleteNews, RequestInputUpdateNews, ResponseAgentNewsById, ResponseAgentNewsList, ResponseCreateNews, ResponseDeleteNews } from "./interface/news/news.interface"

export const getNewsList = async (input: RequestAgentNewsInput): Promise<ResponseAgentNewsList> => {
    const data: AxiosResponse<ResponseAgentNewsList> = await httpClient
      .post(API.getProductNewsList, input)
      .catch(error => handleResponseError(error))
  
    return data.data
  }
  
  export const getNewsById = async (
    newsId: string
  ): Promise<ResponseAgentNewsById> => {
    const data: AxiosResponse<ResponseAgentNewsById> = await httpClient
      .get(API.getProductNewsById + newsId)
      .catch((error) => handleResponseError(error))
    return data.data
  }
  
  export const updateNews = async (input: RequestInputUpdateNews): Promise<ResponseCreateNews> => {
    const data: AxiosResponse<ResponseCreateNews> = await httpClient
      .post(API.updateProductNews, input)
      .catch(error => handleResponseError(error))
  
    return data.data
  }
  
  export const createNews = async (input: RequestInputCreateNews): Promise<ResponseCreateNews> => {
    const data: AxiosResponse<ResponseCreateNews> = await httpClient
      .post(API.createProductNews, input)
      .catch(error => handleResponseError(error))
  
    return data.data
  }
  
  export const deleteNews = async (input : RequestInputDeleteNews): Promise<ResponseDeleteNews> => {
    const data: AxiosResponse<ResponseDeleteNews> = await httpClient
      .post(API.deleteProductNews, input)
      .catch(error => handleResponseError(error))
  
    return data.data
  }